/**
 * Maps arc health status to a CSS modifier class name.
 *
 * Used by ArcDetailOrganism and ArcListMolecule to style health badges.
 * The returned class is a BEM modifier (e.g. "health--on-track")
 * that must be combined with the component's own prefix.
 */
export function getArcHealthModifier(status: string): string {
  switch (status) {
    case 'on_track':
      return 'on-track';
    case 'at_risk':
      return 'at-risk';
    case 'overdue':
      return 'overdue';
    case 'blocked':
      return 'blocked';
    case 'attention_needed':
      return 'attention';
    default:
      return '';
  }
}
